import axios from 'axios';

export default {
  baseUrl() {
    return `${window.api_url}/member/login_codes`;
  },

  create(loginCode, success, failure) {
    return axios.post(this.baseUrl(), { login_code: loginCode }).then(success).catch(failure);
  },
};
